/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * The alarm state:
 *   * DATA_AQUISITION: the event is a tag data acquistion
 *   * ALARM_ACKNOWLEDGEMENT: the aevent is an acknowledgement of an alarm
 *   * ALARM_STATE_UPDATE: the aevent is a alarm state update
 *   * DATA_MIGRATION: the event is from a data migration
 */
export enum EventType {
  DATA_AQUISITION = 'DATA_AQUISITION',
  ALARM_ACKNOWLEDGEMENT = 'ALARM_ACKNOWLEDGEMENT',
  ALARM_STATE_UPDATE = 'ALARM_STATE_UPDATE',
  DATA_MIGRATION = 'DATA_MIGRATION'
}
